import React, { Component } from 'react';
import { Button, Popconfirm, message } from 'antd';
import UpdateModal from './UpdateTrainingExp';
import ComTable from '../ComTable';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class TrainingExp extends Component {
    state = {
        data: [],
        config: [],
        pagination: {
            offset: 1,
            pageSize: 10,
        },
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '培训内容',
            en: 'Training Content',
            key: 'trainingContentShow',
            width: 440,
        }, {
            zh: '培训时间',
            en: 'Training Date',
            key: 'startTimeShow',
        }];
        this.setState({ config }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { userId, isChinese } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryTrainingExperience,
            data: {
                userId,
                offset: current,
                limit: pageSize,
                type: isChinese ? 'CHINESE' : 'ENGLISH',
            },
            dataType: 'json',
            doneResult: res => {
                const { trainingExperienceList = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    loading: false,
                    data: trainingExperienceList,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    update = (record) => {
        this.ref.show(record);
    }

    delete = (row) => {
        const { trainingExperienceId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.delTrainingExperience,
            data: { trainingExperienceId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = ({ pagination }) => {
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    getOperate = () => {
        const { isChinese } = this.props;
        return {
            title: isChinese ? '操作' : 'Operation',
            key: 'operate',
            width: 80,
            render: (text, row) => {
                return (
                    <span>
                        <a onClick={() => this.update(row)}>修改</a>
                        {
                            isChinese ? 
                                <span>
                                    <span className="ant-divider" />
                                    <Popconfirm title="确定要删除吗?" onConfirm={() => this.delete(row)}>
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                            :
                             null
                        }
                    </span>
                );
            }
        };
    }

    getDataSource = () => {
        const { data } = this.state;
        const { isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                startTime,
                endTime,
                trainingContent,
                trainingContentEnglish,
                trainingCommentsChinese,
                trainingCommentsEnglish,
            } = item;
            const trainingComments = isChinese ? trainingCommentsChinese : trainingCommentsEnglish;
            return {
                index: index + 1,
                ...item,
                trainingContentShow: `${isChinese ? trainingContent : trainingContentEnglish}${trainingComments ? `(${trainingComments})` : ''}`,
                startTimeShow: `${startTime.slice(0, 7)}~${endTime ? endTime.slice(0, 7) : isChinese ? '至今' : 'Present'}`,
            }
        });
        return dataSource;
    }

    render() {
        const { userId, canEdit, isChinese } = this.props;
        const { data, config, loading, pagination } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        canEdit && result.push(this.getOperate());
        return (
            <div>
                { canEdit && isChinese && <Button type="primary" onClick={() => this.update()}>新增</Button> }
                <div style={{ marginTop: 20 }}>
                    <ComTable
                        data={data}
                        config={result}
                        loading={loading}
                        pagination={pagination}
                        getDataSource={this.getDataSource}
                        onChange={(params) => this.handleTableChange(params)}
                    />
                </div>
                <UpdateModal ref={el => this.ref = el} userId={userId} isChinese={isChinese} loadData={this.loadData} />
            </div>
        );
    }
}

export default TrainingExp;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/TrainingExp.js